import * as yup from 'yup';
import loadash from 'lodash';

export const deviceTypeDropDownSchema = yup.object().shape({
	id: yup.number().required('Select Device Type').min(1, 'Select Device Type'),
});

export const branchOfficeDropDownSchema = yup.object().shape({
	id: yup.number().required('Select Branch office').min(1, 'Select Device Type'),
});

export const clientDropDownSchema = yup.object().shape({
	id: yup.number().required('Select Client').min(1, 'Select Client'),
});

export const templateDropDown = yup.object().shape({
	id: yup.number().required('Select Template').min(1, 'Select Template'),
});

export const mainLocationDropDown = yup.object().shape({
	id: yup.number().required('Select Main Location').min(1, 'Select Main Location'),
});

export const phoneNumberSchema = yup
	.string()
	.required('Phone Number is a mandatory field')
	.min(10, 'phone number should be 10 digit')
	.max(10, 'phone number should be 10 digit');

export const firstNameSchema = yup.string().required('First Name is mandorty field');

export const lastNameSchema = yup.string().required('Last Name is a mandatory field');

export const passwordSchema = yup
	.string()
	.required('Password is a mandatory field')
	.min(8, 'Password should atleast be minimum 8 letters');

export const usernameSchema = yup
	.string()
	.required('Enter username')
	.matches('^[a-zA-Z0-9_]*$', 'User Name should not contain spaces')
	.min(8, 'Username should be minimum 8 letters');
export const emailIdSchema = yup
	.string()
	.required('Email ID is a mandatory field')
	.email('Enter valid email address');

export const confirmEmailIdSchema = yup
	.string()
	.oneOf([yup.ref('emailId'), null], "Email Ids don't match")
	.required('Confirm Email is required');

export const gstNumberSchema = yup.string().required('GST number is a mandatory field');

export const companyNameSchema = yup
	.string()
	.required('Company name is a mandatory field');

export const confirmPasswordSchema = yup
	.string()
	.oneOf([yup.ref('password'), null], "passwords don't match")
	.required('Password is a mandatory field')
	.min(6, 'Password should atleast be minimum 8 letters');

export const validateSchema = async (schema, requestObject) => {
	try {
		const result = await schema.validate(requestObject, {
			abortEarly: false,
			strict: false,
		});
		return Promise.resolve(result);
	} catch (err) {
		const errorObj = {};
		err.inner.forEach((param) => {
			loadash.set(errorObj, param.path, param.message);
		});
		console.log(errorObj);
		return Promise.reject(errorObj);
	}
};
